import React from 'react';
import {Box} from '@mui/material';
import {constatAge, pctFr} from '../../selectors/analyses.js';
import CarteAnalyse from './CarteAnalyse.js';
import PetitTableau from './PetitTableau.js';

const tauxOuTiret = (t) => (t === null ? '—' : pctFr(t));

/** Carte 2 (réel) : défauts de maintenance selon l'âge d'implantation et le nombre de bacs. `resultat` = defautsParAge(index). */
export default function CarteAge({resultat, lienCarte}) {
    const tranches = resultat.tranches.map((t) => ({cle: t.tranche, a: t.tranche, actes: t.actes, defauts: t.defauts, taux: tauxOuTiret(t.taux)}));
    const bacs = resultat.parBacs.map((b) => ({cle: b.bacs, a: `${b.bacs} bac${b.bacs > 1 ? 's' : ''}`, actes: b.actes, defauts: b.defauts, taux: tauxOuTiret(b.taux)}));
    const cols = (libelle) => [{cle: 'a', libelle}, {cle: 'actes', libelle: 'Actes', droite: true}, {cle: 'defauts', libelle: 'Défauts', droite: true}, {cle: 'taux', libelle: 'Taux', droite: true}];
    return (
        <CarteAnalyse id="analyse-age" titre="Défauts de maintenance selon l'âge" source="reel" constat={constatAge(resultat)} lienCarte={lienCarte}>
            {tranches.length > 0 && (
                <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '24px', alignItems: 'start'}}>
                    <PetitTableau colonnes={cols('Âge du PAV')} lignes={tranches} legende="Taux de défaut par tranche d'âge"/>
                    <PetitTableau colonnes={cols('Bacs')} lignes={bacs} legende="Taux de défaut par nombre de bacs"/>
                </Box>
            )}
        </CarteAnalyse>
    );
}
